export default {
  id: '67cbfa5c11',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\r\n  <div class="page th" data-name="transaction">\r\n\r\n    <!-- Navbar -->\r\n    <div class="navbar th__navbar no-shadow">\r\n      <div class="navbar-bg"></div>\r\n      <div class="navbar-inner">\r\n        <div class="left">\r\n          <a href="#" class="link back th__back" aria-label="Back">\r\n            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="15 18 9 12 15 6"/></svg>\r\n          </a>\r\n        </div>\r\n        <div class="title th__navbar-title">History</div>\r\n        <div class="right"></div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class="page-content th__content" data-type="';
      r += c(ctx_1.type, ctx_1);
      r += '">\r\n\r\n      <!-- Tabs -->\r\n      <div class="th__tabs">\r\n        <button type="button" class="th__tab th__tab--on" data-tab="payments">\r\n          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="2" y="5" width="20" height="14" rx="2"/><line x1="2" y1="10" x2="22" y2="10"/></svg>\r\n          <span>Payments</span>\r\n        </button>\r\n        <button type="button" class="th__tab" data-tab="commissions">\r\n          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg>\r\n          <span>Commissions</span>\r\n        </button>\r\n        <button type="button" class="th__tab" data-tab="withdrawals">\r\n          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><line x1="12" y1="5" x2="12" y2="19"/><polyline points="19 12 12 19 5 12"/></svg>\r\n          <span>Withdrawals</span>\r\n        </button>\r\n      </div>\r\n\r\n      <!-- Status filter (full-width segmented control) -->\r\n      <div class="th__filter-cap">\r\n        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/></svg>\r\n        Filter by status\r\n      </div>\r\n      <div class="th__filters">\r\n        <button type="button" class="th__filter th__filter--on" data-status="all">All<span class="th__filter-c">0</span></button>\r\n        <button type="button" class="th__filter" data-status="success">Success<span class="th__filter-c">0</span></button>\r\n        <button type="button" class="th__filter" data-status="pending">Pending<span class="th__filter-c">0</span></button>\r\n        <button type="button" class="th__filter" data-status="failed">Failed<span class="th__filter-c">0</span></button>\r\n      </div>\r\n\r\n      <!-- List (rendered by routes.js) -->\r\n      <div class="th__list"></div>\r\n\r\n      <div class="th__end-gap"></div>\r\n    </div>\r\n  </div>\r\n';
      return r;
    }(this);
  },
  style: `
/* ════════ TRANSACTION HISTORY (th__*) ════════ */
.th { background: #0A0A0B !important; }
.th__content {
  background:
    radial-gradient(130% 45% at 50% 0%, rgba(201,169,105,0.10) 0%, transparent 56%),
    #0A0A0B !important;
  padding: 14px 14px calc(40px + env(safe-area-inset-bottom)) !important;
  margin-top: 60px !important;
}
.th__navbar { background: linear-gradient(180deg, #100E09 0%, #0B0A07 100%) !important; }
.th__navbar .navbar-bg { background: transparent !important; }
.th__navbar-title { color: var(--gold) !important; font-weight: 700; }
.th__back { color: rgba(201,169,105,0.85) !important; }

/* Tabs — segmented pill with a solid gold active pill */
.th__tabs {
  display: flex; gap: 4px; padding: 4px; border-radius: 15px;
  background: rgba(255,255,255,0.04); border: 1px solid rgba(255,255,255,0.08);
  box-shadow: inset 0 1px 2px rgba(0,0,0,0.3);
}
.th__tab {
  flex: 1; min-width: 0; cursor: pointer;
  display: flex; flex-direction: row; align-items: center; justify-content: center; gap: 6px;
  padding: 10px 6px; border-radius: 12px; border: none; background: transparent;
  color: rgba(255,255,255,0.55); font-size: 12px; font-weight: 700;
  white-space: nowrap; overflow: hidden;
  transition: background .2s ease, color .2s ease, box-shadow .2s ease, transform .12s ease;
}
.th__tab span { overflow: hidden; text-overflow: ellipsis; }
.th__tab svg { opacity: 0.7; flex-shrink: 0; }
.th__tab:active { transform: scale(0.97); }
.th__tab--on {
  background: linear-gradient(135deg, #e5c98f 0%, #C9A969 48%, #a07c38 100%);
  color: #1a1206;
  box-shadow: 0 8px 18px -8px rgba(201,169,105,0.75), inset 0 1px 0 rgba(255,255,255,0.4);
}
.th__tab--on svg { opacity: 1; }

/* Filters — full-width segmented status control (secondary to the tabs).
   NOTE: F7's base rule button{width:100%} forces bare buttons full-width, so the
   segments MUST use flex:1 (flex-basis:0 overrides that width), same as .th__tab. */
.th__filter-cap {
  display: flex; align-items: center; gap: 6px; margin: 16px 2px 8px;
  font-size: 11px; font-weight: 700; letter-spacing: 0.05em; text-transform: uppercase;
  color: rgba(201,169,105,0.62);
}
.th__filter-cap svg { color: rgba(201,169,105,0.7); }
.th__filters {
  display: flex; gap: 4px; padding: 4px; border-radius: 13px;
  background: rgba(255,255,255,0.04); border: 1px solid rgba(255,255,255,0.08);
  box-shadow: inset 0 1px 2px rgba(0,0,0,0.25);
}
.th__filter {
  flex: 1; min-width: 0; cursor: pointer;
  display: inline-flex; align-items: center; justify-content: center; gap: 4px;
  padding: 9px 4px; border-radius: 10px; border: 1px solid transparent; background: transparent;
  color: rgba(255,255,255,0.58); font-size: 11.5px; font-weight: 700; white-space: nowrap;
  transition: background .16s ease, color .16s ease, border-color .16s ease, transform .12s ease;
}
.th__filter:active { transform: scale(0.97); }
.th__filter-c {
  font-size: 10.5px; font-weight: 800; color: rgba(255,255,255,0.42);
  font-variant-numeric: tabular-nums;
}
.th__filter-c::before { content: '('; }
.th__filter-c::after  { content: ')'; }
/* Active segment adopts its own status color */
.th__filter--on { color: #fff; }
.th__filter--on .th__filter-c { color: currentColor; opacity: 0.8; }
.th__filter--on[data-status="all"]     { background: linear-gradient(155deg, rgba(201,169,105,0.26), rgba(201,169,105,0.07)); border-color: rgba(201,169,105,0.45); color: #f3e2b6; }
.th__filter--on[data-status="success"] { background: linear-gradient(155deg, rgba(74,222,128,0.22), rgba(74,222,128,0.06)); border-color: rgba(74,222,128,0.42); color: #bff2d3; }
.th__filter--on[data-status="pending"] { background: linear-gradient(155deg, rgba(251,191,36,0.22), rgba(251,191,36,0.06)); border-color: rgba(251,191,36,0.42); color: #f7e3b2; }
.th__filter--on[data-status="failed"]  { background: linear-gradient(155deg, rgba(248,113,113,0.22), rgba(248,113,113,0.06)); border-color: rgba(248,113,113,0.42); color: #f7c6c6; }

/* List */
.th__list { margin-top: 16px; display: flex; flex-direction: column; }

/* Day group header (Today / Yesterday / date) */
.th__day {
  font-size: 10.5px; font-weight: 700; letter-spacing: 0.06em; text-transform: uppercase;
  color: rgba(201,169,105,0.62); margin: 10px 3px 8px;
}
.th__day:first-child { margin-top: 2px; }

.th__item {
  position: relative; overflow: hidden; width: 100%; text-align: left;
  display: flex; align-items: center; gap: 12px; margin-bottom: 9px;
  padding: 12px 12px 12px 17px;
  background: linear-gradient(160deg, #17140f 0%, #110f0d 100%);
  border: 1px solid rgba(201,169,105,0.12); border-radius: 16px;
  cursor: pointer;
  transition: transform .12s ease, border-color .18s ease, background .18s ease;
}
.th__item:active { transform: scale(0.992); border-color: rgba(201,169,105,0.32); background: linear-gradient(160deg, #1b1710 0%, #141210 100%); }
/* direction rail down the left edge */
.th__item::before {
  content: ''; position: absolute; left: 0; top: 0; bottom: 0; width: 3px;
}
.th__item--in::before  { background: linear-gradient(180deg, #4ADE80, rgba(74,222,128,0.25)); }
.th__item--out::before { background: linear-gradient(180deg, #F87171, rgba(248,113,113,0.25)); }
.th__item-ico {
  flex-shrink: 0; width: 38px; height: 38px; border-radius: 12px;
  display: flex; align-items: center; justify-content: center;
}
.th__item-ico--out { background: linear-gradient(160deg, rgba(248,113,113,0.17), rgba(248,113,113,0.05)); color: #F87171; box-shadow: inset 0 0 0 1px rgba(248,113,113,0.20); }
.th__item-ico--in  { background: linear-gradient(160deg, rgba(74,222,128,0.17), rgba(74,222,128,0.05)); color: #4ADE80; box-shadow: inset 0 0 0 1px rgba(74,222,128,0.20); }
.th__item-body { flex: 1; min-width: 0; display: block; }
.th__item-top { display: flex; align-items: baseline; justify-content: space-between; gap: 10px; }
.th__item-title { font-size: 13.5px; font-weight: 700; color: #fff; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.th__item-amt { flex-shrink: 0; font-size: 15px; font-weight: 800; white-space: nowrap; font-variant-numeric: tabular-nums; letter-spacing: -0.01em; }
.th__item-amt--out { color: rgba(255,255,255,0.92); }
.th__item-amt--in { color: #4ADE80; }
/* status pill — shared by the list card and the details sheet */
.th__badge {
  flex-shrink: 0; display: inline-flex; align-items: center; gap: 5px;
  padding: 3px 8px; border-radius: 20px;
  font-size: 9.5px; font-weight: 700; line-height: 1.4; white-space: nowrap;
}
.th__badge-dot { width: 5px; height: 5px; border-radius: 50%; flex-shrink: 0; }
.th__badge--success { background: rgba(74,222,128,0.12); color: #4ADE80; }
.th__badge--success .th__badge-dot { background: #4ADE80; }
.th__badge--pending { background: rgba(251,191,36,0.12); color: #fbbf24; }
.th__badge--pending .th__badge-dot { background: #fbbf24; }
.th__badge--failed  { background: rgba(248,113,113,0.12); color: #F87171; }
.th__badge--failed  .th__badge-dot { background: #F87171; }

/* single meta line: status, context, date — same on every tab */
.th__item-meta { display: flex; align-items: center; gap: 7px; margin-top: 6px; min-width: 0; }
.th__item-sub {
  flex: 1; min-width: 0; font-size: 11px; color: rgba(255,255,255,0.44);
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
}
.th__item-date { flex-shrink: 0; font-size: 10px; color: rgba(255,255,255,0.30); }
.th__item-go {
  flex-shrink: 0; width: 20px; height: 20px; border-radius: 7px;
  display: flex; align-items: center; justify-content: center;
  background: rgba(201,169,105,0.10); color: rgba(201,169,105,0.8);
}

/* loading */
.th__loading {
  display: flex; align-items: center; justify-content: center; gap: 9px;
  padding: 40px 0; font-size: 13px; color: rgba(255,255,255,0.42);
}
.th__spin-ring {
  width: 17px; height: 17px; border-radius: 50%; flex-shrink: 0;
  border: 2px solid rgba(201,169,105,0.25); border-top-color: #C9A969;
  animation: th-spin 0.8s linear infinite;
}
@keyframes th-spin { to { transform: rotate(360deg); } }

/* rich empty / error state */
.th__empty {
  display: flex; flex-direction: column; align-items: center;
  text-align: center; padding: 48px 28px 40px;
}
.th__empty-ico {
  width: 64px; height: 64px; border-radius: 20px; margin: 0 auto 16px;
  display: flex; align-items: center; justify-content: center; position: relative;
  background: radial-gradient(120% 120% at 50% 0%, rgba(201,169,105,0.16), rgba(201,169,105,0.05));
  box-shadow: inset 0 0 0 1px rgba(201,169,105,0.20); color: #C9A969;
}
.th__empty-ico::after {
  content: ''; position: absolute; inset: -6px; border-radius: 24px;
  border: 1px solid rgba(255,255,255,0.04);
}
.th__empty-ico--err {
  background: radial-gradient(120% 120% at 50% 0%, rgba(248,113,113,0.14), rgba(248,113,113,0.04));
  box-shadow: inset 0 0 0 1px rgba(248,113,113,0.18); color: #F87171;
}
.th__empty-title { font-size: 15px; font-weight: 700; color: rgba(255,255,255,0.82); margin: 0; }
.th__empty-sub { font-size: 12.5px; color: rgba(255,255,255,0.40); margin: 7px 0 0; line-height: 1.55; max-width: 250px; }

.th__end-gap { height: 30px; }

/* ── Transaction details sheet (ths__*) ── */
.ths {
  height: auto; max-height: 86vh;
  flex-direction: column;
  border-radius: 24px 24px 0 0;
  background:
    radial-gradient(120% 50% at 50% 0%, rgba(201,169,105,0.13) 0%, transparent 62%),
    linear-gradient(180deg, #17150F 0%, #121110 100%);
  border-top: 1px solid rgba(201,169,105,0.28);
  box-shadow: 0 -20px 50px -20px rgba(0,0,0,0.9);
}
/* Same specificity trap as .brk: F7's own .sheet-modal.modal-in display:block rule
   beats a bare .ths, collapsing the column so a long detail list overflows the sheet. */
.sheet-modal.ths.modal-in,
.sheet-modal.ths.modal-in-swipe-step { display: flex; }
.ths__grip {
  width: 38px; height: 4px; border-radius: 3px; margin: 9px auto 4px; flex-shrink: 0;
  background: rgba(255,255,255,0.18);
}
.ths__head { display: flex; align-items: center; gap: 12px; padding: 10px 20px 0; flex-shrink: 0; }
.ths__ico {
  flex-shrink: 0; width: 42px; height: 42px; border-radius: 13px;
  display: flex; align-items: center; justify-content: center;
}
.ths__ico--out { background: linear-gradient(160deg, rgba(248,113,113,0.17), rgba(248,113,113,0.05)); color: #F87171; box-shadow: inset 0 0 0 1px rgba(248,113,113,0.20); }
.ths__ico--in  { background: linear-gradient(160deg, rgba(74,222,128,0.17), rgba(74,222,128,0.05)); color: #4ADE80; box-shadow: inset 0 0 0 1px rgba(74,222,128,0.20); }
.ths__head-txt { flex: 1; min-width: 0; display: flex; flex-direction: column; align-items: flex-start; gap: 6px; }
.ths__title { font-size: 15.5px; font-weight: 800; color: #fff; letter-spacing: -0.01em; }
.ths__amount {
  padding: 14px 20px 4px; flex-shrink: 0;
  font-size: 30px; font-weight: 800; letter-spacing: -0.02em; font-variant-numeric: tabular-nums;
}
.ths__amount--in  { color: #4ADE80; }
.ths__amount--out { color: #fff; }
.ths__amount small {
  display: block; font-size: 11px; font-weight: 600; letter-spacing: 0;
  color: rgba(74,222,128,0.85); margin-top: 4px;
}
.ths__scroll { flex: 1; min-height: 0; overflow-y: auto; -webkit-overflow-scrolling: touch; padding: 12px 20px 0; }
.ths__rows {
  background: rgba(0,0,0,0.26);
  border: 1px solid rgba(255,255,255,0.06);
  border-radius: 15px; padding: 4px 14px;
}
.ths__row {
  display: flex; align-items: baseline; justify-content: space-between; gap: 14px;
  padding: 11px 0; border-bottom: 1px solid rgba(255,255,255,0.05);
}
.ths__row:last-child { border-bottom: none; }
.ths__row-l { font-size: 11.5px; color: rgba(255,255,255,0.45); flex-shrink: 0; }
.ths__row-v {
  font-size: 12.5px; font-weight: 700; color: rgba(255,255,255,0.90);
  text-align: right; min-width: 0; word-break: break-all; font-variant-numeric: tabular-nums;
}
.ths__row-v--mono { font-family: ui-monospace, SFMono-Regular, Menlo, monospace; font-size: 11px; font-weight: 600; color: rgba(255,255,255,0.72); }
.ths__row-v--fee { color: #ff8b7c; }
.ths__row-v--net { color: #4ADE80; font-size: 14px; font-weight: 800; }
.ths__row-v--in  { color: #4ADE80; }
.ths__row-v--out { color: rgba(255,255,255,0.92); }
/* width:auto is required — F7's global button rule is width:100%, which combined
   with side margins pushes this past the sheet's right edge. */
.ths__done {
  flex-shrink: 0; width: auto; display: block;
  margin: 14px 20px calc(16px + env(safe-area-inset-bottom));
  height: 48px; border: none; border-radius: 15px; cursor: pointer;
  background: linear-gradient(135deg, #f3da92 0%, #C9A969 45%, #a07c38 100%);
  color: #1a1206; font-size: 14.5px; font-weight: 800;
  box-shadow: 0 10px 24px -10px rgba(201,169,105,0.75), inset 0 1px 0 rgba(255,255,255,0.38);
}
.ths__done:active { transform: scale(0.985); filter: brightness(1.05); }
`,
  styleScoped: false
};